import { render, staticRenderFns } from "./advertiserManageAdd.vue?vue&type=template&id=2eb97183&scoped=true"
import script from "./advertiserManageAdd.vue?vue&type=script&lang=js"
export * from "./advertiserManageAdd.vue?vue&type=script&lang=js"
import style0 from "./advertiserManageAdd.vue?vue&type=style&index=0&id=2eb97183&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb97183",
  null
  
)

export default component.exports